/*
 * ar-collab-models.js
 * sections/ar-collab-models.liquid の動作。
 * - グリッド表示: 「もっと見る」アコーディオン（initial_mobile/pc 件で折りたたみ）
 * - 横スクロール表示: 1枚ずつの自動スライダー（autoplay）
 */
(function () {
  function initSlider(root) {
    if (!root.classList.contains('ar-cm--scroll')) return;
    if (root.dataset.arCmSlider === 'true') return;
    root.dataset.arCmSlider = 'true';

    var grid = root.querySelector('[data-ar-cm-grid]');
    var items = grid ? grid.querySelectorAll('[data-ar-cm-item]') : [];
    if (!grid || items.length < 2) return;

    var autoplay = root.dataset.autoplay !== 'false';
    var speed = (parseFloat(root.dataset.autoplaySpeed) || 3) * 1000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    function slideWidth() {
      var gap = parseFloat(getComputedStyle(grid).columnGap) || 16;
      return items[0].getBoundingClientRect().width + gap;
    }
    function step() {
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      if (grid.scrollLeft >= maxScroll - 2) {
        grid.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        grid.scrollBy({ left: slideWidth(), behavior: 'smooth' });
      }
    }
    function start() { if (autoplay && !reduce && !timer) timer = setInterval(step, speed); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    ['pointerdown', 'touchstart', 'mouseenter'].forEach(function (ev) {
      grid.addEventListener(ev, stop, { passive: true });
    });
    ['touchend', 'pointerup', 'mouseleave'].forEach(function (ev) {
      grid.addEventListener(ev, start, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });
    start();
  }

  function init(root) {
    if (root.dataset.arCmInit === 'true') return;
    root.dataset.arCmInit = 'true';

    const items = root.querySelectorAll('[data-ar-cm-item]');
    const toggle = root.querySelector('[data-ar-cm-toggle]');
    if (!items.length || !toggle) return;

    const initialMobile = parseInt(root.dataset.initialMobile, 10) || 6;
    const initialPc = parseInt(root.dataset.initialPc, 10) || 8;
    let expanded = false;
    const mq = window.matchMedia('(min-width: 750px)');

    function applyState() {
      const initial = mq.matches ? initialPc : initialMobile;
      let hiddenCount = 0;
      items.forEach(function (item, i) {
        const shouldHide = !expanded && i >= initial;
        item.classList.toggle('is-hidden', shouldHide);
        if (shouldHide) hiddenCount++;
      });
      const showToggle = items.length > initial;
      toggle.hidden = !showToggle;
      const text = toggle.querySelector('.ar-cm__more-text');
      const icon = toggle.querySelector('.ar-cm__more-icon');
      if (expanded) {
        if (text) text.textContent = '閉じる';
        if (icon) icon.textContent = '▲';
      } else {
        if (text) text.textContent = 'もっと見る';
        if (icon) icon.textContent = '▼';
      }
    }

    toggle.addEventListener('click', function () {
      expanded = !expanded;
      applyState();
    });

    if (mq.addEventListener) {
      mq.addEventListener('change', applyState);
    } else if (mq.addListener) {
      mq.addListener(applyState);
    }
    applyState();
  }

  function initAll() {
    document.querySelectorAll('[data-ar-cm]').forEach(function (root) {
      init(root);
      initSlider(root);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target.querySelector('[data-ar-cm]');
    if (root) {
      root.dataset.arCmInit = 'false';
      root.dataset.arCmSlider = 'false';
      init(root);
      initSlider(root);
    }
  });
})();
